"use strict";

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.unscopables.flat.js");

var _defineProperty = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/defineProperty");

var _construct = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeWordLimitsFromFields = exports.removeIndexPrefixFromUrl = exports.prepareSearchableFields = exports.prepareFilterFields = exports.mergeArraysWithoutWordLimits = exports.getWordLimitForKey = exports.getSearchableFromArr = exports.getFieldsWithoutDecorators = exports.extractLang = exports.cutTextWithWordsLimit = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _stripHtml = require("./strip-html");

var removeWordLimitsFromFields = function removeWordLimitsFromFields(arr) {
  return arr.map(function (item) {
    return item.split(',');
  }).flat().map(function (item) {
    return item.split(':')[0];
  });
};

exports.removeWordLimitsFromFields = removeWordLimitsFromFields;

var getWordLimitForKey = function getWordLimitForKey(key, arr) {
  var item = arr === null || arr === void 0 ? void 0 : arr.find(function (field) {
    var _field$split = field.split(':'),
        _field$split2 = _slicedToArray(_field$split, 1),
        attr = _field$split2[0];

    return key === attr;
  });
  if (!item) return undefined;

  var _item$split = item.split(':'),
      _item$split2 = _slicedToArray(_item$split, 2),
      value = _item$split2[1];

  return value ? Number(value) : undefined;
};

exports.getWordLimitForKey = getWordLimitForKey;

var getSearchableFromArr = function getSearchableFromArr(arr) {
  return arr === null || arr === void 0 ? void 0 : arr.filter(function (item) {
    return item.startsWith('searchable');
  }).map(function (item) {
    var reParam = /\((\w*)\)/;
    var param = item.match(reParam);

    if (param) {
      return param[1];
    }

    return null;
  }).filter(function (item) {
    return item !== null;
  });
};

exports.getSearchableFromArr = getSearchableFromArr;

var mergeArraysWithoutWordLimits = function mergeArraysWithoutWordLimits(arrays) {
  return _toConsumableArray(_construct(Set, [arrays.filter(Boolean).map(function (arr) {
    return removeWordLimitsFromFields(arr);
  }).flat()]));
};

exports.mergeArraysWithoutWordLimits = mergeArraysWithoutWordLimits;

var cutTextWithWordsLimit = function cutTextWithWordsLimit(value, numberOfWords) {
  if (typeof value !== 'string') {
    return '';
  }

  if (typeof numberOfWords !== 'number') {
    return value;
  }

  return value.trim().split(/\s+/).slice(0, numberOfWords).join(' ');
};

exports.cutTextWithWordsLimit = cutTextWithWordsLimit;

var prepareSearchableFields = function prepareSearchableFields(settings, data) {
  var fields = mergeArraysWithoutWordLimits([settings === null || settings === void 0 ? void 0 : settings.attributesToSnippet, settings === null || settings === void 0 ? void 0 : settings.searchableAttributes, getSearchableFromArr(settings === null || settings === void 0 ? void 0 : settings.attributesForFaceting)]);
  return fields.reduce(function (acc, key) {
    if (removeWordLimitsFromFields((settings === null || settings === void 0 ? void 0 : settings.attributesToSnippet) || []).includes(key)) {
      acc[key] = {
        value: cutTextWithWordsLimit((0, _stripHtml.stripHtml)(data[key]), getWordLimitForKey(key, settings === null || settings === void 0 ? void 0 : settings.attributesToSnippet))
      };
    } else {
      acc[key] = data[key];
    }

    return acc;
  }, {});
};

exports.prepareSearchableFields = prepareSearchableFields;

var extractLang = function extractLang(value) {
  return value && value.lang ? value.lang.split('-')[0] : 'en';
};

exports.extractLang = extractLang;

var removeIndexPrefixFromUrl = function removeIndexPrefixFromUrl(obj) {
  if (typeof obj === 'object' && obj !== null && typeof obj.url === 'string') {
    var _obj$url;

    var url = (_obj$url = obj.url) === null || _obj$url === void 0 ? void 0 : _obj$url.replace(/^.*###/, '');
    return _objectSpread(_objectSpread({}, obj), {}, {
      url: url
    });
  }

  return obj;
};

exports.removeIndexPrefixFromUrl = removeIndexPrefixFromUrl;

var getFieldsWithoutDecorators = function getFieldsWithoutDecorators(fields) {
  return Array.isArray(fields) ? fields.map(function (item) {
    var fieldNameRe = /\((.*)\)/;
    var fieldName = item.match(fieldNameRe);
    return fieldName ? fieldName[1] : item;
  }).filter(Boolean) : fields;
};

exports.getFieldsWithoutDecorators = getFieldsWithoutDecorators;

var prepareFilterFields = function prepareFilterFields(settings, data) {
  var fieldKeys = getFieldsWithoutDecorators(settings.attributesForFaceting);
  return (fieldKeys === null || fieldKeys === void 0 ? void 0 : fieldKeys.reduce(function (acc, field) {
    var itemData = (0, _get2.default)(data, field);

    if (!itemData) {
      var parentField = field.split('.')[0];
      var childField = field.split('.').pop();

      if (childField) {
        itemData = (0, _get2.default)(data, parentField);

        if (Array.isArray(itemData)) {
          itemData = itemData.filter(Boolean).map(function (item) {
            return item[childField];
          });
        }
      }
    }

    if (itemData) {
      var onlyObjects = Array.isArray(itemData) ? itemData.filter(Boolean).filter(function (item) {
        return Object.keys(item).length !== 0;
      }) : [String(itemData)];

      if (onlyObjects.some(function (item) {
        return item.id;
      })) {
        acc["".concat(field, ".id")] = onlyObjects.filter(function (item) {
          return item.id;
        }).map(function (item) {
          return String(item.id);
        });
      } else {
        acc[field] = Array.isArray(itemData) ? itemData.filter(Boolean).map(function (item) {
          return String(item);
        }) : [String(itemData)];
      }
    }

    return acc;
  }, {})) || {};
};

exports.prepareFilterFields = prepareFilterFields;